import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const SpeedometerIcon = forwardRef<SVGSVGElement, Props>(
	(props, ref) => (
		<svg
			width="1em"
			height="1em"
			viewBox="0 0 16 16"
			xmlns="http://www.w3.org/2000/svg"
			ref={ref}
			{...props}
		>
			<path
				fill="currentColor"
				d="M1 8.83q.001-.786.175-1.524a.75.75 0 0 1 .903-.564.76.76 0 0 1 .557.914Q2.5 8.223 2.5 8.83c0 1.509.651 2.876 1.709 3.848a.766.766 0 0 1 .05 1.072.744.744 0 0 1-1.059.052A6.74 6.74 0 0 1 1 8.83m12.5 0c0-2.904-2.433-5.312-5.5-5.312a5.6 5.6 0 0 0-3.69 1.373q-.231.204-.439.43a.744.744 0 0 1-1.06.043.765.765 0 0 1-.042-1.072q.265-.29.561-.55A7.08 7.08 0 0 1 8 2c3.837 0 7 3.03 7 6.83a6.73 6.73 0 0 1-2.2 4.973.744.744 0 0 1-1.06-.052.766.766 0 0 1 .051-1.072q.091-.084.18-.172A5.2 5.2 0 0 0 13.5 8.831"
			></path>
			<path
				fill="currentColor"
				d="M2.754 4.344a.743.743 0 0 1 1.06-.033l4.7 4.473a.765.765 0 0 1 .032 1.073.744.744 0 0 1-1.06.033l-4.7-4.474a.765.765 0 0 1-.032-1.072"
			></path>
		</svg>
	),
)
